import { render, staticRenderFns } from "./VesselParticularsEvents.vue?vue&type=template&id=796ac515&"
import script from "./VesselParticularsEvents.vue?vue&type=script&lang=js&"
export * from "./VesselParticularsEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports